import { render } from "./PackagingList.vue?vue&type=template&id=03457ef8"
import script from "./PackagingList.vue?vue&type=script&lang=js"
export * from "./PackagingList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bauminas/hml/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__